
import { applicationStartup } from '../configuration/temporary/application.startup';
import { ApplicationOptions, IApplication, createApplication } from './application';

export const applicationBootstapper = applicationStartup().start();
const applicationOptions:ApplicationOptions = {
  serviceProvider: applicationBootstapper.serviceProvider
}

export const application = createApplication(applicationOptions);

